import { addFieldEditor } from "aldoo-ra/CMS/field-editor-resolver"
import { addApi } from "aldoo-ra/CMS/field-api-resolver"
import { addFormatter } from "aldoo-ra/CMS/field-formatter"
import { addDisplayFormatter } from "aldoo-ra/CMS/field-display-format-resolver"
import { addFieldValidator } from "aldoo-ra/CMS/field-validator-resolver"
import StorePriceAPI from "./api"
import StorePriceFormatter from "./formatters/store-price-formatter"
import StorePriceEditor from "./editors/store-price-editor"
import { priceSearchResult } from "./display-formatters"
import { PriceModelType } from "../PriceModel"
import priceModelValidator from "aldoo-ra/CMS/field-validators/price-model-validator"

// Main StorePrice type
export const StorePrice = {
    type: "StorePrice",
    label: "",
    groups: [
        {
            id: "config",
            label: "Configuration",
            description: "Basic configuration for the store price.",
            expanded: true,
        },
        {
            id: "price",
            label: "Price Model",
            description: "Add supported price models",
            hidePanel: true,
            expanded: true,
        },
        {
            id: "meta",
            label: "Metadata",
            description: "Meta information",
            expanded: true,
        }
    ],
    fields: [
        {
            id: "enabled",
            label: "Enabled",
            type: "Boolean",
            description: "Whether this price configuration is active",
            default: true,
            group: "config",
            visibleIf: () => false
        },
        {
            id: "price_model",
            label: "Price Models",
            type: "Array",
            required: true,
            description: "Configure pricing across different platforms and plans",
            group: "price",
            fieldEditor: "PriceModelEditor",
            item: PriceModelType,
            render: { variant: "full" },
            validators: {
                PriceModelValidator: {}
            }
        },

        {
            id: "meta",
            render: { variant: "full" },
            label: "Metadata",
            type: "Object",
            description: "Additional metadata for the price configuration",
            group: "meta",
            visibleIf: () => false
        }
    ]
};

addApi("StorePrice", StorePriceAPI)
addFormatter("StorePrice", StorePriceFormatter)
addFieldEditor("StorePrice", StorePriceEditor)
addDisplayFormatter("priceSearchResult", priceSearchResult)
addFieldValidator("PriceModelValidator", priceModelValidator)

// Register this type in DatabaseModelTypeResolver for dynamic access
export const RegisterInDBResolver = true